/**
 * 주보 게시판 컴포넌트
 */

import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { MainLayout } from '../../../../shared/components';
import { BoardList } from '../../../../shared/components/Board/BoardList/BoardList';
import { Button } from '../../../../shared/components/UI/Button';
import { theme } from '../../../../shared/styles/theme';
import { mediaQueries } from '../../../../shared/constants/breakpoints';
import { useBoard } from '../../../../shared/hooks';

const PageContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: ${theme.spacing.xxxl} ${theme.spacing.lg};

  ${mediaQueries.maxMobile} {
    padding: ${theme.spacing.xl} ${theme.spacing.md};
  }
`;

const PageTitle = styled.h1`
  font-size: ${theme.fontSizes.xxxl};
  font-weight: 700;
  color: ${theme.colors.primary};
  text-align: center;
  margin-bottom: ${theme.spacing.md};
  font-family: ${theme.fonts.heading};

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.xxl};
  }
`;

const PageSubtitle = styled.p`
  font-size: ${theme.fontSizes.lg};
  color: ${theme.colors.textLight};
  text-align: center;
  margin-bottom: ${theme.spacing.xxxl};

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.md};
  }
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${theme.spacing.lg};
  margin-top: ${theme.spacing.xxxl};
`;

const PageInfo = styled.span`
  font-weight: 600;
  color: ${theme.colors.text};
  min-width: 80px;
  text-align: center;
`;

export const Bulletin: React.FC = () => {
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  // React Query로 게시글 목록 조회 (자동 캐싱)
  const { data, isLoading } = useBoard('bulletin', { page, limit: 9 });

  const posts = data?.data || [];
  const totalPages = data?.pagination.totalPages || 1;

  const handlePostClick = (postId: number) => {
    navigate(`/community/bulletin/${postId}`);
  };

  return (
    <MainLayout>
      <PageContainer>
        <PageTitle>주보</PageTitle>
        <PageSubtitle>주일 예배 주보를 확인하실 수 있습니다</PageSubtitle>
        <BoardList posts={posts} onPostClick={handlePostClick} />

        {totalPages > 1 && (
          <Pagination>
            <Button onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1}>
              이전
            </Button>
            <PageInfo>
              {page} / {totalPages}
            </PageInfo>
            <Button
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
              disabled={page === totalPages}
            >
              다음
            </Button>
          </Pagination>
        )}
      </PageContainer>
    </MainLayout>
  );
};
